import "./Contact.css";
import { Button, Card, SectionHeading } from "@adafia/ui";
import { ChevronRight, Github, Linkedin, Mail } from "lucide-react";
import { useEffect, useState } from "react";
import { useMessage } from "../hooks/useMessage";

const Contact = () => {
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const { messageRequest, sendMessage, reset } = useMessage();

	useEffect(() => {
		if (messageRequest.status === "success") {
			setName("");
			setEmail("");
			setMessage("");
			const timer = setTimeout(() => {
				reset();
			}, 5000);
			return () => clearTimeout(timer);
		}
		return;
	}, [messageRequest.status, reset]);

	const invalidForm =
		name === "" || email === "" || message === "" || message.length < 10;

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		sendMessage({ name, email, message });
	};

	return (
		<section id="contact">
			<div className="contact-container">
				<div className="contact-header">
					<SectionHeading>Get in touch</SectionHeading>
					<p className="contact-intro">
						Whether you have a question about sustainable energy tech or just
						want to say hi, I'll try my best to get back to you!
					</p>
				</div>
				<form onSubmit={handleSubmit}>
					<Card className="form-card">
						<div className="form-group">
							<label className="form-label" htmlFor="name">
								Name
							</label>
							<input
								id="name"
								type="text"
								className="form-input"
								placeholder="Kofi Mensah"
								value={name}
								onChange={(e) => setName(e.target.value)}
								required
							/>
						</div>
						<div className="form-group">
							<label className="form-label" htmlFor="email">
								Email
							</label>
							<input
								id="email"
								type="email"
								className="form-input"
								placeholder="kofi.mensah@gmail.com"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
							/>
						</div>
						<div className="form-group">
							<label className="form-label" htmlFor="message">
								Message
							</label>
							<textarea
								id="message"
								rows={4}
								className="form-input"
								placeholder="Hello, I would like to have a chat about..."
								value={message}
								onChange={(e) => setMessage(e.target.value)}
								required
							/>
							{message.length > 0 && message.length < 10 && (
								<p className="validation-error">
									Message must be at least 10 characters.
								</p>
							)}
						</div>
						<Button
							size="sm"
							className="btn-primary"
							disabled={messageRequest.status === "loading" || invalidForm}
						>
							{messageRequest.status === "loading"
								? "Sending..."
								: "Send message"}{" "}
							<ChevronRight size={16} />
						</Button>
						{messageRequest.status === "success" && (
							<p className="success-message">Message sent successfully!</p>
						)}
						{messageRequest.status === "error" && (
							<div className="send-message-fallback">
								<p>
									{messageRequest.message ||
										"Something went wrong! Try sending a direct email instead."}
								</p>
								<a
									href="mailto:adafia.samuel@gmail.com"
									className="contact-email"
								>
									<Mail size={24} />
									adafia.samuel@gmail.com
								</a>
							</div>
						)}
					</Card>
				</form>

				<div className="social-links">
					<a
						href="mailto:adafia.samuel@gmail.com"
						className="social-item"
						aria-label="Send me an email"
					>
						<div className="social-icon-box">
							<Mail size={20} />
						</div>
						<span className="social-label">Email</span>
					</a>
					<a
						href="https://github.com/adafia"
						className="social-item"
						aria-label="My GitHub profile"
					>
						<div className="social-icon-box">
							<Github size={20} />
						</div>
						<span className="social-label">GitHub</span>
					</a>
					<a
						href="https://www.linkedin.com/in/samuel-a-08418894"
						className="social-item"
						aria-label="My LinkedIn profile"
					>
						<div className="social-icon-box">
							<Linkedin size={20} />
						</div>
						<span className="social-label">LinkedIn</span>
					</a>
				</div>
			</div>
		</section>
	);
};

export default Contact;
